import selectComponent from './select.component';
import 'ui-select';
import 'angular-sanitize';

let selectModule = angular.module('components.selectApp', [
  'ui.select',
  'ngSanitize'
])

.component('selectApp', selectComponent)

.name;

export default selectModule;



// WEBPACK FOOTER //
// ./client/app/components/select/select.js